import { QuestionAnswerContainer } from "../containers/question-answer"

export const QuestionAnswer = () => {
    return (
        <QuestionAnswerContainer />
    )
}